angular.module('qkr').factory('pushNotificationService', ($http, appConfig) => {
    const createDepartmentMenuAndMenuItemCommand = function(departmentId, menuId, menuItemId) {
        return {
            departmentId,
            menuId,
            menuItemId
        };
    };

    return {
        getPushNotificationContextForMenuItem: (departmentId, menuId, menuItemId) => {
            const departmentMenuAndMenuItemCommand = createDepartmentMenuAndMenuItemCommand(departmentId, menuId, menuItemId);

            return $http.post(appConfig.apiUrl + 'pushNotification/getProductPushNotificationContext', departmentMenuAndMenuItemCommand)
                .then((response) => response.data,
                        (reason) => reason);
        },

        getProductPushNotificationAvailabilityListForMenu: (departmentId, menuId) => {
            const departmentMenuAndMenuItemCommand = createDepartmentMenuAndMenuItemCommand(departmentId, menuId, null);

            return $http.post(appConfig.apiUrl + 'pushNotification/getProductPushNotificationAvailabilityList', departmentMenuAndMenuItemCommand)
                .then((response) => response.data,
                        (reason) => reason);
        },
        sendProductPushNotification: (departmentId, menuId, menuItemId, segments) => {
            const sendProductPushNotificationCommand = {
                departmentId,
                menuId,
                menuItemId,
                segments
            };

            return $http.post(appConfig.apiUrl + 'pushNotification/sendProductPushNotification', sendProductPushNotificationCommand)
                .then((response) => response,
                        (reason) => reason);
        },

        getPushNotificationConfig: () => {
            return $http.get(appConfig.apiUrl + 'pushNotification/getPushNotificationConfig', {withCredentials: true});
        },

        getPushNotificationOutletConfig: (isoCode) => {
            return $http.get(appConfig.apiUrl + 'pushNotification/getPushNotificationOutletConfig/' + isoCode, {withCredentials: true});
        },

        sendPushNotification: (form) => {
            return $http.post(appConfig.apiUrl + 'pushNotification/sendPushNotification', form)
        },

        killPushNotifications: () => {
            return $http.get(appConfig.apiUrl + 'pushNotification/killPushNotifications', {withCredentials: true});
        },

        checkDetail: (detail, category) => {
            var checkDetail = {
                detail: detail,
                category: category
            }
            return $http.post(appConfig.apiUrl + 'pushNotification/checkDetail', checkDetail)
        }

    };
});



// WEBPACK FOOTER //
// ./src/services/pushNotification.service.js